import { Button, Col, Modal, Row, Select, Table } from "antd"
import { ColumnsType } from "antd/es/table"
import React, { useCallback, useMemo, useState } from "react"
import { PlusOutlined } from "@ant-design/icons"
import "../VisorMartillo.css"
import { TableRowSelection } from "antd/lib/table/interface"
import { VisorReporteOrdenCompra } from "hooks/compras/useGenerarOrden"

export interface ProveedorPromocion {
  key: React.Key
  proveedor: string
  cantidad: number
  boni: number
  desc: number
  pvf: number
  costo: number
  inicio_validez: string
  fin_validez: string
  Cod_Producto: number
}

interface Props {
  data: ProveedorPromocion[] | undefined
  loading?: boolean
  //rowSelectionProveedor: TableRowSelection<ProveedorPromocion>
  selectkeyProveedorinit: React.Key
  setselectkeyProveedor: Function
  dataProductosOrden: VisorReporteOrdenCompra[]
  setdataProductosOrden: Function
}

const columns: ColumnsType<ProveedorPromocion> = [
  {
    title: "Proveedor",
    dataIndex: "proveedor",
    key: "proveedor",
    ellipsis: true,
    width: "150px",
  },
  {
    title: "Cant",
    dataIndex: "Cantidad",
    key: "cantidad",
    align: "right",
    width: "40px",
  },
  {
    title: "Boni",
    dataIndex: "Boni",
    key: "boni",
    align: "right",
    width: "40px",
  },
  {
    title: "Desc",
    dataIndex: "desc",
    key: "desc",
    align: "right",
    render: (text) => {
      const num = Number(text)
      const truncated = Math.trunc(num * 100) / 100
      return truncated.toFixed(2)
    },
  },
  {
    title: "PVF",
    dataIndex: "PVF",
    key: "pvf",
    align: "right",
    render: (text) => {
      const num = Number(text)
      const truncated = Math.trunc(num * 100) / 100
      return truncated.toFixed(2)
    },
  },

  {
    title: "Costo",
    dataIndex: "Costo",
    key: "costo",
    align: "right",
    width: "50px",
    render: (text) => {
      const num = Number(text)
      const truncated = Math.trunc(num * 100) / 100
      return truncated.toFixed(2)
    },
  },
  {
    title: "Inicio Validez",
    dataIndex: "Inicio_Validez",
    key: "Inicio_Validez",
  },
  {
    title: "Fin Validez",
    dataIndex: "Fin_Validez",
    key: "Fin_Validez",
  },
]

const PromocionesProveedor: React.FC<Props> = ({
  data,
  loading,
  selectkeyProveedorinit,
  setselectkeyProveedor,
  dataProductosOrden,
  setdataProductosOrden,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const OnChangeSelectionProveedor = useCallback(
    async (newSelectedRowKeys: React.Key[]) => {
      const proveedor: ProveedorPromocion | undefined = data?.find((item) => item.key === Number(selectkeyProveedorinit))
      const proveedornew: ProveedorPromocion | undefined = data?.find((item) => item.key === newSelectedRowKeys[0])
      if (proveedor) {
        const updatedData = dataProductosOrden.map((item) => {
          if (item.Cod_Proveedor === proveedor.key && item.Cod_Producto === proveedor.Cod_Producto) {
            return {
              ...item,
              Cod_Proveedor: proveedornew?.key,
              Proveedor: proveedornew?.proveedor,
              Pedir_Mia: 0,
              Pedir_Sg: 0,
              Boni_Mia: 0,
              Boni_Sg: 0,
            }
          }
          return item
        })
        setdataProductosOrden(updatedData)
      }
      setselectkeyProveedor(newSelectedRowKeys[0])
    },
    [setselectkeyProveedor, data, dataProductosOrden, selectkeyProveedorinit, setdataProductosOrden]
  )

  const rowSelectionProveedor: TableRowSelection<ProveedorPromocion> = useMemo(
    () => ({
      selectedRowKeys: [Number(selectkeyProveedorinit)],
      columnWidth: "20px",
      onChange: OnChangeSelectionProveedor,
      type: "radio",
      getCheckboxProps: (item) => ({ disabled: Number(selectkeyProveedorinit) > 0 ? false : true }),
    }),
    [selectkeyProveedorinit, OnChangeSelectionProveedor]
  )

  return (
    <>
      <Table
        title={() => (
          <Row>
            <Col md={12} xs={12} sm={12} style={{ textAlign: "left" }}>
              Promociones Proveedor
            </Col>
            <Col md={12} sm={12} xs={12}>
              <Row justify={"end"}>
                {Number(selectkeyProveedorinit) > 0 && (
                  <Button size={"small"} type="primary" icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)} />
                )}
              </Row>
            </Col>
          </Row>
        )}
        className="custom-table-visor"
        columns={columns}
        rowSelection={rowSelectionProveedor}
        dataSource={data}
        loading={loading}
        pagination={false}
        rowKey="key"
        scroll={{ x: 100, y: 60 }}
        // scroll={{ x: 180, y: 65 }}
        bordered
        size="small"
      />
      <Modal title="Agregar Promoción" open={isModalOpen} onCancel={() => setIsModalOpen(false)}>
        <Row>
          <Col sm={4} xs={4} md={4} style={{ paddingBottom: "2px" }}>
            Proveedor
          </Col>
          <Col sm={20} xs={20} md={20}>
            <Select size="small" style={{ width: "100%" }} />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm={4} xs={4} md={4}>
            Proveedor
          </Col>
          <Col sm={20} xs={20} md={20}>
            <Select size="small" style={{ width: "100%" }} />{" "}
          </Col>
        </Row>
      </Modal>
    </>
  )
}

export default PromocionesProveedor
